module.exports = __webpack_public_path__ + "img/estado-success.9807e311.svg";